var React = require('react');

function TagClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.66634 1.7735L8.72634 0.833496L4.99967 4.56016L1.27301 0.833496L0.333008 1.7735L4.05967 5.50016L0.333008 9.22683L1.27301 10.1668L4.99967 6.44016L8.72634 10.1668L9.66634 9.22683L5.93967 5.50016L9.66634 1.7735Z","fill":"white"}));
}

TagClose.defaultProps = {"width":"10","height":"11","viewBox":"0 0 10 11","fill":"none"};

module.exports = TagClose;

TagClose.default = TagClose;
